// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blocked-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 100vh;
}

.blocked-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 20px;
  border: 1px solid #E8E9F0;
  border-radius: 12px;
  background-color: #FFF;
  max-width: 600px;
}

.blocked-icon {
  width: 56px;
  height: 56px;
}

.blocked-title {
  font-size: 22px;
  color: #002E33;
  margin-bottom: 20px;
}

.blocked-text {
  font-size: 14px;
  color: #002E33;
  text-align: center;
  line-height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/client/Other/Blocked.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,aAAA;AADJ;;AAIA;EACI,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBCRI;EDSJ,gBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,eAAA;EACA,cCzBW;ED0BX,mBAAA;AADJ;;AAIA;EACI,eAAA;EACA,cC/BW;EDgCX,kBAAA;EACA,iBAAA;AADJ","sourcesContent":["@import '../Global/Colors';\n\n.blocked-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.blocked-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    border: 1px solid $Gray30;\n    border-radius: 12px;\n    background-color: $White;\n    max-width: 600px;\n}\n\n.blocked-icon {\n    width: 56px;\n    height: 56px;\n}\n\n.blocked-title {\n    font-size: 22px;\n    color: $DeepSeaGreen;\n    margin-bottom: 20px;\n}\n\n.blocked-text {\n    font-size: 14px;\n    color: $DeepSeaGreen;\n    text-align: center;\n    line-height: 22px;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
